function addDays(date: Date, days: number): Date {
  const d = new Date(date);

  return new Date(d.getFullYear(), d.getMonth(), d.getDate() + days);
}

function subtractDays(date: Date, days: number): Date {
  const d = new Date(date);

  return new Date(d.getFullYear(), d.getMonth(), d.getDate() - days);
}

function getUserTimeZoneDisplay(): string {
  const now = new Date();

  // IANA time zone name
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Human readable time zone name
  const timeZoneName = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "long",
  })
    .formatToParts(now)
    .find((part) => part.type === "timeZoneName")?.value;

  // Calculate UTC offset
  const offsetInMinutes = now.getTimezoneOffset();
  const offsetHours = Math.floor(-offsetInMinutes / 60);
  const offsetSign = offsetHours >= 0 ? "+" : "";
  const utcOffset = `UTC${offsetSign}${offsetHours}`;

  return `${timeZoneName} (${utcOffset})`;
}

function isJulyFourth(date: Date = new Date()): boolean {
  return date.getMonth() === 6 && date.getDate() === 4;
}

export { addDays, subtractDays, getUserTimeZoneDisplay, isJulyFourth };
